import React, { useState, useEffect } from "react";
import Modal from "../Modal";
import styled from "@emotion/styled";
import SelectWithLabel from "../../Inputs/Select";
import { isMobile } from "react-device-detect";
import { Alert } from "../Alert";
import { FieldContainer } from "../../StyledComponents/Forms/Forms";
import TextInputWithLabel from "../../Inputs/TextInput";
import PrescriptionTable, { PrescriptionTableRedesignTwoColumn } from "../Opticians/PrescriptionTable";
import { YesNoSelect } from "../../Inputs/Select";
import { createPrivateOrder, fetchPrescriptionMeasures, fetchCoatsAndTintsForLens, fetchLensBrand, fetchLensDropDownSelections, fetchPrivateFrames, fetchEyewearOptions } from "../../../http/optician";
import RichTextBoxWithLabel from "../../Inputs/RichTextBoxWithLabel";
import { LoadingScreen } from "../../StyledComponents/Forms/Loader";
import {
  StyledPagination,
  InputContainer,
  Label,
  StyledSelect,
  StyledButton,
  StyledSearchInput,
} from "../../StyledComponents/Table/TableComponents";
import { Row } from "../../StyledComponents/Forms/Forms";
import FrameModal from "./FrameModal";
import { isValidUKPostcode } from '../../Helpers/postcodeFns';
import { StyledModal } from "../../StyledComponents/Modals/Modals";
import { fetchAccount } from "../../../http/account";

const SmallStyledModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  max-width: 500px;
`;

const SmallModalHeader = styled.h3`
  margin-top: 0;
  color: #333;
  text-align: center;
`;

const SmallModalBody = styled.div`
  margin: 20px 0;
`;

const WarningBox = styled.div`
  background-color: #fff3cd;
  border-left: 8px solid #ffeeba;
  padding: 15px;
  margin-bottom: 20px;
`;

const SmallModalFooter = styled.div`
  text-align: right;
`;

const FrameCardContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const FrameCard = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
`;

const FrameImageContainer = styled.div`
  flex: 0 1 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #FFFFFF;
`;

const FrameContentContainer = styled.div`
  padding: 20px;
  flex: 0 1 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const FrameName = styled.h3`
  margin: 0;
  margin-bottom: 15px;
  font-size: 1.3em;
  color: #333;
`;

const FrameDetail = styled.p`
  margin: 5px 0;
  color: #666;
  font-size: 0.8em;
`;

const FrameDetailTitle = styled.span`
  font-weight: bold;
  color: #333;
`;


const PrescriptionContainerTwoColumn = styled.div`
  display: flex;
  justify-content: space-between;
  width: ${isMobile ? "100%" : "50%"};
  float: right;
`;

const PrescriptionContainerLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${isMobile ? "100%" : "50%"};
  float: left;
  overflow: hidden;
`;

const StepsHeader = styled.div`
  background-color: ${({ backGroundColour }) => backGroundColour};
  color: ${({ fontColour }) => fontColour};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const Step = styled.div`
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  background: #cccccc;
  color: white;
  text-align: center;
  font-size: 0.9em;
`;

const ActiveStep = styled(Step)`
  background-color: #4caf50;
`;

const StepLabel = styled.span`
  display: inline-block;
  padding: 0 ${isMobile ? "4px" : "15px"};
  color: ${({ fontColour }) => fontColour};
`;

const StepContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ModalBody = styled.div`
  max-height: ${isMobile ? "500px" : "720px"};
  overflow-y: auto;
  width: 100%;
  padding: 0px 40px ${isMobile ? "0px" : "30px"} 40px;
  flex-grow: 1;
`;

const ModalFooter = styled.div`
  text-align: right;
  flex-shrink: 0;
  padding: 10px 0px;
`;

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  padding-bottom: 20px;
`;

const ImageContainer = styled.div`
  flex: 0 0 150px;
  height: 115px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #FFFFFF;
`;

const Card = styled.div`
  display: flex;
  width: 100%;
  max-width: 400px;
  height: ${isMobile ? "150px" : "115px"};
  border: 2px solid ${({ isSelected }) => (isSelected ? "#4caf50" : "#ddd")};
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: #fff;
  transition: transform 0.2s, border-color 0.3s;

  &:hover {
    transform: scale(1.02);
    cursor: pointer;
  }
`;

const ContentContainer = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
`;

const ButtonSection = styled.div`
  flex: 0 0 50px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  background-color: #e7f3ff;
  border-left: 1px solid #ddd;

  &:hover {
    background-color: #b0d7ff;
  }
`;

const InfoButton = styled.button`
  background-color: transparent;
  border: none;
  font-size: 1.5em;
  color: #2e96ff;
  cursor: pointer;
`;


const CancelButton = styled.button`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #5a6268;
  }
`;

const Button = styled.button`
  background-color: #93c572;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  padding: 10px 20px;
  margin-right: 10px;

  &:hover {
    background-color: #698d51;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const defaultOrder = {
  privatePatient: {
    firstName: "",
    secondName: ""
  },
  frameID: 0,
  requireSideshields: "Yes",
  lenseID: 0,
  lenseCoatID: 0,
  lenseTintID: 0,
  casesID: 0,
  prescription: {
    rightEye: {
      sphere: "0.00",
      cylinder: "0.00",
      axis: "0",
      hPrism: null,
      hPrismDirection: '-',
      vPrism: null,
      vPrismDirection: '-',
      distanceOC: "0.00",
      readOC: "0.00",
      intermediateOC: "0.00",
      add: null,
      heights: null
    },
    leftEye: {
      sphere: "0.00",
      cylinder: "0.00",
      axis: "0",
      hPrism: null,
      hPrismDirection: '-',
      vPrism: null,
      vPrismDirection: '-',
      distanceOC: "0.00",
      readOC: "0.00",
      intermediateOC: "0.00",
      add: null,
      heights: null
    },
    svDistOrRead: 0
  },
  standardLensPrescription: {
    rightEye: {
      sphere: "0.00",
      cylinder: "0.00",
      axis: "0",
      hPrism: null,
      hPrismDirection: "-",
      vPrism: null,
      vPrismDirection: "-",
      distanceOC: "0.00",
      readOC: "0.00",
      intermediateOC: "0.00",
      add: null,
      heights: null
    },
    leftEye: {
      sphere: "0.00",
      cylinder: "0.00",
      axis: "0",
      hPrism: null,
      hPrismDirection: "-",
      vPrism: null,
      vPrismDirection: "-",
      distanceOC: "0.00",
      readOC: "0.00",
      intermediateOC: "0.00",
      add: null,
      heights: null
    },
    svDistOrRead: 0
  },
  rxNotes: "",
  postageandPackingOption: 4,
  rxShippingOption: 0,
  deliveryAddress: {
    companyname: "",
    coaddress1: "",
    coaddress2: "",
    coaddress3: "",
    coaddress4: "",
    copostcode: ""
  },
  orderType: "Catalogue",
  orderNumber: "",
  promotionCode: "",
  isDailyOrderTrackingRequested: 0
};

export default function PrivateOrder({ showHideModal, isModalOpen, colours, order = null }) {
  const stepTitles = ["1", "2", "3"];
  const stepDescriptions = ["Frames", "Prescription", "Patient Details"];
  const [account, setAccount] = useState({});

  const [orderDetails, setOrderDetails] = useState(!order ? defaultOrder : order);
  const [missingFields, setMissingFields] = useState({});
  const [invalidPostcode, setInvalidPostcode] = useState('');


  const [currentStep, setCurrentStep] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [frames, setFrames] = useState([]);

  const [zeroSphCheck, setZeroSphCheck] = useState(false);
  const [zeroSphCheckConfirmed, setZeroSphCheckConfirmed] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [materialFilter, setMaterialFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState((isMobile ? 6 : 18));
  const [arrPageSizes] = useState((isMobile ? [6, 12, 24, 48] : [9, 18, 36, 72]));

  const [showFrameDetails, setShowFrameDetails] = useState(false);
  const [selectedFrameInfo, setSelectedFrameInfo] = useState(null);

  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  const [lensMaterials, setLensMaterials] = useState(null);
  const [lensTypes, setLensTypes] = useState(null);

  const [lensBrands, setLensBrands] = useState([]);
  const [svTypes, setSvTypes] = useState([]);

  const [svType, setSvType] = useState(null);

  const [lensCoatings, setLensCoatings] = useState([]);
  const [lensTints, setLensTints] = useState([]);
  const [lensCases, setLensCases] = useState([]);

  const [prescriptionMeasures, setPrescriptionMeasures] = useState(null);
  const [eyewearOptions, setEyewearOptions] = useState([]);
  const [invalidPromoCode, setInvalidPromoCode] = useState(false);

  const [isDeliveryAlternate, setIsDeliveryAlternate] = useState(false);

  const cloneDefaultOrder = () => JSON.parse(JSON.stringify(defaultOrder));

  useEffect(() => {
    if (isModalOpen) {
      setOrderDetails(order ? JSON.parse(JSON.stringify(order)) : cloneDefaultOrder());
      setCurrentStep(0);
      setSelectedMaterial(null);
      setSelectedType(null);
      setSelectedFrameInfo(null);
      setSvType(null);
      setZeroSphCheck(false);
      setZeroSphCheckConfirmed(false);
      setMissingFields({});
      setInvalidPostcode('');
      setInvalidPromoCode(false);
      setIsDeliveryAlternate(false);
    }
  }, [isModalOpen]);

  useEffect(() => {
    const loadAccount = async () => {
      setIsLoading(true);
      try {
        const fetchedAccount = await fetchAccount();
        setAccount(fetchedAccount.Users_Profile);

        if (order === null) {
          handleEnteredValues('isDailyOrderTrackingRequested', parseInt(fetchedAccount.Users_Profile.IsDailyOrderStatusReportRequested === true ? 1 : 0));
        }

        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    };
    loadAccount();
  }, []);

  useEffect(() => {
    const resetPrescription = () => {
      ['RightEye', 'LeftEye'].forEach((eye) => {
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.add`, null);
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.heights`, null);
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.hPrism`, null);
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.hPrismDirection`, "-");
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.vPrism`, null);
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.vPrismDirection`, "-");
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.distanceOC`, "0.00");
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.readOC`, "0.00");
        handleEnteredValues(`prescription.${eye === 'RightEye' ? 'rightEye' : 'leftEye'}.intermediateOC`, "0.00");
      });
    };

    resetPrescription();
  }, [selectedType]);

  function handleEnteredValues(identifier, value) {
    setOrderDetails((prevValues) => {
      const keys = identifier.split('.');
      const lastKey = keys.pop();
      const deepClone = { ...prevValues };

      let nestedObject = deepClone;
      keys.forEach((key) => {
        if (!nestedObject[key]) nestedObject[key] = {};
        nestedObject = nestedObject[key];
      });

      if (lastKey === "distanceOC") {
        const readOcValue = Number(value) - 1.5;
        nestedObject["readOC"] = readOcValue.toFixed(2).toString();
      }

      nestedObject[lastKey] = value;

      return deepClone;
    });
  }

  const handleSavePrivateOrder = async () => {
    let isComplete = true;
    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    const preparedOrderDetails = {
      ...orderDetails,
      prescription: {
        ...orderDetails.prescription,
        svDistOrRead: svType === 'Distance' || selectedType !== "Single Vision" ? 0 : svType === 'Readers' ? 1 : 2,
      },
      rxShippingOption: isDeliveryAlternate ? 1 : 0,
    };

    if (preparedOrderDetails.deliveryAddress?.companyname === "") {
      delete preparedOrderDetails.deliveryAddress;
    }

    setCurrentStep(999);

    let response = null;

    try {
      response = await createPrivateOrder(preparedOrderDetails);

      if (response === "Invalid PromoCode") {
        isComplete = false;
        setInvalidPromoCode(true);
        return;
      }
      setError(null);
    } catch (e) {
      isComplete = false;
      setError(e);
    } finally {
      setIsLoading(false);
      if (isComplete) {
        window.dispatchEvent(new CustomEvent('privateOrderCompleted', {
          detail: { 
            response: JSON.parse(JSON.stringify(response)), 
            orderDetails: JSON.parse(JSON.stringify(preparedOrderDetails)) 
          }
        }));
        showHideModal(true);
      }
    }
  };

  const validateForm = () => {
    let newMissingFields = {};
    let newInvalidData = {};
    let isValid = true;

    if (currentStep === 0 && orderDetails.frameID === 0) {
      newMissingFields.frameID = true;
    }

    if (currentStep === 1) {
      if (!orderDetails.lenseID || orderDetails.lenseID === 0) { newMissingFields.lenseID = true; }
      if (!selectedType || selectedType === 0) { newMissingFields.selectedType = true; }

      if ((selectedType === "Bifocal" || selectedType === "Progressive") || selectedType === "Single Vision" && svType !== "Intermediate") {
        if (!orderDetails.prescription.rightEye.distanceOC || orderDetails.prescription.rightEye.distanceOC === "0.00") { newMissingFields.RightDistanceOC = true; }
        if (!orderDetails.prescription.leftEye.distanceOC || orderDetails.prescription.leftEye.distanceOC === "0.00") { newMissingFields.LeftDistanceOC = true; }
        if (!orderDetails.prescription.rightEye.readOC || orderDetails.prescription.rightEye.readOC === "0.00") { newMissingFields.RightReadOC = true; }
        if (!orderDetails.prescription.leftEye.readOC || orderDetails.prescription.leftEye.readOC === "0.00") { newMissingFields.LeftReadOC = true; }
      }

      if (selectedType === "Single Vision" && svType === "Intermediate") {
        if (!orderDetails.prescription.rightEye.intermediateOC || orderDetails.prescription.rightEye.intermediateOC === "0.00") { newMissingFields.RightIntermediateOC = true; }
        if (!orderDetails.prescription.leftEye.intermediateOC || orderDetails.prescription.leftEye.intermediateOC === "0.00") { newMissingFields.LeftIntermediateOC = true; }
      }

      if (selectedType === "Single Vision" || (selectedType === "Bifocal" || selectedType === "Progressive")) {
        if (!orderDetails.prescription.rightEye.sphere) { newMissingFields.RightSphere = true; }
        if (!orderDetails.prescription.leftEye.sphere) { newMissingFields.LeftSphere = true; }

        if (!orderDetails.prescription.rightEye.cylinder) { newMissingFields.RightCylinder = true; }
        if (!orderDetails.prescription.leftEye.cylinder) { newMissingFields.LeftCylinder = true; }

        if (!orderDetails.prescription.rightEye.axis || orderDetails.prescription.rightEye.axis === "0") { newMissingFields.RightAxis = true; }
        if (!orderDetails.prescription.leftEye.axis || orderDetails.prescription.leftEye.axis === "0") { newMissingFields.LeftAxis = true; }
      }

      if (selectedType === "Bifocal" || selectedType === "Progressive") {
        if (!orderDetails.prescription.rightEye.add) { newMissingFields.RightAdd = true; }
        if (!orderDetails.prescription.leftEye.add) { newMissingFields.LeftAdd = true; }

        if (!orderDetails.prescription.rightEye.heights) { newMissingFields.RightHeights = true; }
        if (!orderDetails.prescription.leftEye.heights) { newMissingFields.LeftHeights = true; }
      }

    }

    if (currentStep === 2) {
      if (orderDetails.privatePatient.firstName === "") { newMissingFields.firstName = true; }
      if (orderDetails.privatePatient.secondName === "") { newMissingFields.secondName = true; }
      if (orderDetails.orderNumber === "") { newMissingFields.orderNumber = true; }

      if (isDeliveryAlternate) {
        if (orderDetails.deliveryAddress.companyname === "") { newMissingFields.companyname = true; }
        if (orderDetails.deliveryAddress.coaddress1 === "") { newMissingFields.coaddress1 = true; }
        if (orderDetails.deliveryAddress.coaddress2 === "") { newMissingFields.coaddress2 = true; }
        if (orderDetails.deliveryAddress.coaddress3 === "") { newMissingFields.coaddress3 = true; }
        if (orderDetails.deliveryAddress.copostcode === "") { newMissingFields.copostcode = true; }

        if (!isValidUKPostcode(orderDetails.deliveryAddress.copostcode)) {
          setInvalidPostcode('Please enter a valid UK postcode');
          isValid = false;
        }
      }
    }

    for (let key in newMissingFields) {
      if (newMissingFields[key] === true) {
        isValid = false;
        break;
      }
    }

    if (currentStep === 1 && !zeroSphCheckConfirmed && isValid &&
      (
        orderDetails.prescription.rightEye.sphere === "0.00"
        || orderDetails.prescription.leftEye.sphere === "0.00"
      )
    ) {
      setZeroSphCheck(true);
      isValid = false;
    }

    setMissingFields(newMissingFields);
    return isValid;
  };

  const zeroSphModal = zeroSphCheck && (
    <SmallStyledModal>
      <SmallModalHeader>Zero Sphere?</SmallModalHeader>
      <ModalBody>
        <WarningBox>
          <strong>Zero Sphere Value</strong>
          <p>You have entered the value '0.00' for either the left, or right eye sphere. Is this correct?</p>
        </WarningBox>
      </ModalBody>
      <ModalFooter>
        <CancelButton onClick={() => setZeroSphCheck(false)}>No</CancelButton>
        <Button onClick={() => {
          setZeroSphCheckConfirmed(true);
        }}>Yes</Button>
      </ModalFooter>
    </SmallStyledModal>
  );

  const setDefaultValues = () => {
    const d = new Date();
    let stringDate = d.toISOString();

    const initialValues = {
      privatePatient: {
        firstName: "",
        secondName: ""
      },
      frameID: 0,
      requireSideshields: "Yes",
      lenseID: 0,
      lenseCoatID: 0,
      lenseTintID: 0,
      casesID: 0,
      prescription: {
        rightEye: {
          sphere: 0,
          cylinder: 0,
          axis: 0,
          hPrism: 0,
          hPrismDirection: "In",
          vPrism: 0,
          vPrismDirection: "Up",
          distanceOC: 0,
          readOC: 0,
          intermediateOC: 0,
          add: 0,
          heights: 0
        },
        leftEye: {
          sphere: 0,
          cylinder: 0,
          axis: 0,
          hPrism: 0,
          hPrismDirection: "0F00",
          vPrism: 0,
          vPrismDirection: "Up",
          distanceOC: 0,
          readOC: 0,
          intermediateOC: 0,
          add: 0,
          heights: 0
        },
        svDistOrRead: 0
      },
      rxNotes: "",
      postageandPackingOption: 4,
      rxShippingOption: 0,
      deliveryAddress: {
        companyname: "",
        coaddress1: "",
        coaddress2: "",
        coaddress3: "",
        coaddress4: "",
        copostcode: ""
      },
      orderType: "Catalogue",
      orderNumber: "",
      promotionCode: false
    };

    setOrderDetails(prevState => ({ ...prevState, ...initialValues }));
  };

  const nextStep = () => {
    if (validateForm()) {
      if (currentStep < stepTitles.length - 1) {
        setCurrentStep(currentStep + 1);
      }
    }
  };

  const deliveryAddressOptions = [
    { label: 'Optician Address', value: 0 },
    { label: 'Alternative Address', value: 1 }
  ];

  useEffect(() => {
    const loadFrames = async () => {
      setIsLoading(true);
      try {
        const framesData = await fetchPrivateFrames();
        setFrames(framesData.Frames || []);
        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    };

    const loadLensMaterialsAndTypes = async () => {
      setIsLoading(true);
      try {
        const lensOptions = await fetchLensDropDownSelections();

        const restructuredMaterials = [{ label: 'Select a lens material..', value: '' }];
        restructuredMaterials.push(...lensOptions["Lens Material"].map(material => ({
          label: material,
          value: material
        })));

        const restructuredTypes = [{ label: 'Select a lens type..', value: '' }];
        restructuredTypes.push(...lensOptions["Lens Type"].map(type => ({
          label: type,
          value: (type === "D28 Bifocal" ? "Bifocal" : type)
        })));

        setLensMaterials(restructuredMaterials || []);
        setLensTypes(restructuredTypes || []);
        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    };

    loadFrames();
    loadLensMaterialsAndTypes();
  }, []);

  const loadLensTintsAndCoatings = async () => {
    if (orderDetails.lenseID) {
      setIsLoading(true);
      try {
        const response = await fetchCoatsAndTintsForLens(orderDetails.lenseID);

        if (response.Coats) {
          const restructuredCoats = [{ label: 'Select a lens coating..', value: '0' }];
          restructuredCoats.push(...response.Coats.map(coat => ({
            label: coat.descrip,
            value: coat.unid
          })));

          setLensCoatings(restructuredCoats || []);
        }

        if (response.Cases) {
          const restructuredCases = [];
          restructuredCases.push(...response.Cases.map(cases => ({
            label: cases.descrip,
            value: cases.unid
          })));

          setLensCases(restructuredCases || []);
          handleEnteredValues('casesID', restructuredCases[0].value);
        }

        if (response.Tints) {
          const restructuredTints = [{ label: 'Select a lens tint..', value: '0' }];
          restructuredTints.push(...response.Tints.map(tint => ({
            label: tint.descrip,
            value: tint.unid
          })));

          setLensTints(restructuredTints || []);
        }

        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    loadPrescriptionMeasures();
    loadDockingExtras();
  }, [orderDetails.lenseID, orderDetails.frameID, svType]);

  const loadDockingExtras = async () => {
    if (orderDetails.lenseID) {
      setIsLoading(true);
      try {
        const response = await fetchEyewearOptions(orderDetails.lenseID);

        if (response.length) {
          const restructuredCases = [];
          restructuredCases.push(...response.map(eyewearCase => ({
            label: eyewearCase.descrip,
            value: eyewearCase.unid
          })));

          setEyewearOptions(restructuredCases || []);
        } else {
          setEyewearOptions([]);
        }

        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const loadPrescriptionMeasures = async () => {
    if (orderDetails.frameID && orderDetails.lenseID) {
      setIsLoading(true);
      try {
        const response = await fetchPrescriptionMeasures(orderDetails.lenseID, orderDetails.frameID, svType);

        setPrescriptionMeasures(response);

        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const loadLensBrand = async () => {
    if (orderDetails.frameID && selectedMaterial && selectedType) {
      setIsLoading(true);
      try {
        const response = await fetchLensBrand(orderDetails.frameID, selectedMaterial, selectedType);

        if (response.length) {
          if (response[0].SVType) {
            const restructuredSVTypes = [];
            restructuredSVTypes.push(...response[0].SVType.map(type => ({
              label: type,
              value: type
            })));

            setSvTypes(restructuredSVTypes || []);
            if(restructuredSVTypes.length > 0 && restructuredSVTypes[0].value){
            setSvType(restructuredSVTypes[0].value);
            }
          } else {
            setSvTypes([]);
          }

          const restructuredBrands = [{ label: 'Select a lens brand..', value: '' }];
          restructuredBrands.push(...response.map(brand => ({
            label: brand.LensBrand,
            value: brand.lenunidcode
          })));

          setLensBrands(restructuredBrands || []);
        }

        setError(null);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    loadLensTintsAndCoatings();
  }, [orderDetails.lenseID]);

  useEffect(() => {
    loadLensBrand();
  }, [selectedMaterial, selectedType]);


  useEffect(() => {
    setCurrentPage(0);
  }, [searchTerm, pageSize, materialFilter]);

  function ShowHideFrameDetails() {
    setShowFrameDetails(!showFrameDetails);
  }

  const handleMoreInfoClick = (event, frame) => {
    event.stopPropagation();
    setSelectedFrameInfo(frame);
    ShowHideFrameDetails();
  };

  const filteredFrames = frames
    .filter((frame) => frame.frameName.toLowerCase().includes(searchTerm.toLowerCase()))
    .filter((frame) => (materialFilter ? frame.frameMaterial === materialFilter : true));

  const paginatedFrames = filteredFrames.slice(
    currentPage * pageSize,
    (currentPage + 1) * pageSize
  );

  return (
    <>
      <Modal open={zeroSphCheck && !zeroSphCheckConfirmed}>
        {zeroSphCheck && !zeroSphCheckConfirmed && zeroSphModal}
      </Modal>
      {showFrameDetails &&
        <FrameModal
          showHideModal={ShowHideFrameDetails}
          isModalOpen={showFrameDetails}
          frame={selectedFrameInfo} />}
      <Modal open={isModalOpen}>
        <StyledModal maxWidth={isMobile ? "975px" : "1500px"}>
          <StepsHeader backGroundColour={colours.sidebar} fontColour={colours.font}>
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
              {stepTitles.map((number, index) => (
                <StepContainer key={index}>
                  {currentStep === index ? <ActiveStep>{number}</ActiveStep> : <Step>{number}</Step>}
                  <StepLabel fontColour={colours.font}>{stepDescriptions[index]}</StepLabel>
                </StepContainer>
              ))}
            </div>
          </StepsHeader>
          {error && !isLoading && <Alert type="error">Unable to process request due to <b>{error.message}</b></Alert>}
          {isLoading && currentStep === 999 &&
            <ModalBody>
              <LoadingScreen
                value="Please wait whilst we process your Private Order, this may take a few moments.."
                size="60px"
                borderColor="#d3d3d3"
                topColor={colours.sidebar}
              />
            </ModalBody>
          }
          {!isLoading && !error && (
            <ModalBody>
              {currentStep === 0 && (
                <>
                  <h3>Select a frame</h3>
                  <Alert type="info">
                    Click a frame to select it and press <span><b>'Next'</b></span> to enter the prescription. You can click the <span><b>'i'</b></span> icon for more information about each  frame
                  </Alert>
                  <Row>
                    <InputContainer>
                      <Label>Search Frames:</Label>
                      <StyledSearchInput
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder={`Search ${filteredFrames.length} frames...`}
                      />
                    </InputContainer>
                    <InputContainer>
                      <Label>Filter by Material:</Label>
                      <StyledSelect
                        value={materialFilter}
                        onChange={(e) => setMaterialFilter(e.target.value)}
                      >
                        <option value="">All Materials</option>
                        {Array.from(new Set(frames.map((frame) => frame.frameMaterial))).map(
                          (material, index) => (
                            <option key={index} value={material}>
                              {material}
                            </option>
                          )
                        )}
                      </StyledSelect>
                    </InputContainer>
                  </Row>
                  <CardContainer>
                    {paginatedFrames.map((frame, index) => (
                      <Card
                        key={`${frame.frameName}-${index}`}
                        isSelected={orderDetails.frameID === frame.frameId}
                        onClick={() => {
                          handleEnteredValues('frameID', frame.frameId);
                          setSelectedFrameInfo(frame);
                        }}
                      >
                        <ImageContainer>
                          <img
                            src={`https://www.mcrsafetyeurope.com/${frame.Image_A}`}
                            alt="Frame"
                            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                          />
                        </ImageContainer>
                        <ContentContainer>
                          <FrameName>{frame.frameName}</FrameName>
                          <FrameDetail>Material: {frame.frameMaterial}</FrameDetail>
                          <FrameDetail>Type: {frame.frametype}</FrameDetail>
                        </ContentContainer>
                        <ButtonSection onClick={(event) => handleMoreInfoClick(event, frame)}>
                          <InfoButton>
                            i
                          </InfoButton>
                        </ButtonSection>
                      </Card>
                    ))}
                  </CardContainer>
                  <StyledPagination>
                    <InputContainer>
                      <Label>
                        Page <strong>{currentPage + 1} of {Math.ceil(filteredFrames.length / pageSize)}</strong>
                      </Label>
                      <StyledSelect
                        value={pageSize}
                        onChange={(e) => {
                          setPageSize(Number(e.target.value));
                          setCurrentPage(0);
                        }}
                      >
                        {arrPageSizes.map((size) => (
                          <option key={size} value={size}>
                            Show {size}
                          </option>
                        ))}
                      </StyledSelect>
                    </InputContainer>
                    <div>
                      <StyledButton onClick={() => setCurrentPage(0)} disabled={currentPage === 0}>
                        {'<<'}
                      </StyledButton>{' '}
                      <StyledButton onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))} disabled={currentPage === 0}>
                        {'<'}
                      </StyledButton>{' '}
                      <StyledButton onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredFrames.length / pageSize) - 1))} disabled={currentPage === Math.ceil(filteredFrames.length / pageSize) - 1}>
                        {'>'}
                      </StyledButton>{' '}
                      <StyledButton onClick={() => setCurrentPage(Math.ceil(filteredFrames.length / pageSize) - 1)} disabled={currentPage === Math.ceil(filteredFrames.length / pageSize) - 1}>
                        {'>>'}
                      </StyledButton>
                    </div>
                  </StyledPagination>
                </>
              )}
              {currentStep === 1 && (
                <>
                  <PrescriptionContainerLeft>
                    <FrameCardContainer>
                      <FrameCard>
                        <FrameImageContainer>
                          <img
                            src={`https://www.mcrsafetyeurope.com/${selectedFrameInfo.Image_A}`}
                            alt="Frame"
                            style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                          />
                        </FrameImageContainer>
                        <FrameContentContainer>
                          <FrameName>{selectedFrameInfo.frameName}</FrameName>
                          <FrameDetail>
                            <FrameDetailTitle>Material: </FrameDetailTitle>{selectedFrameInfo.frameMaterial}
                          </FrameDetail>
                          <FrameDetail>
                            <FrameDetailTitle>Type: </FrameDetailTitle>{selectedFrameInfo.frametype}
                          </FrameDetail>
                          <FrameDetail>
                            <FrameDetailTitle>Colour: </FrameDetailTitle>{selectedFrameInfo.frameColour}
                          </FrameDetail>
                          <FrameDetail>
                            <FrameDetailTitle>Size: </FrameDetailTitle>{selectedFrameInfo.frameSize}
                          </FrameDetail>
                          <FrameDetail>
                            <FrameDetailTitle>Temple Length: </FrameDetailTitle>{selectedFrameInfo.frtemplength} mm
                          </FrameDetail>
                          <FrameDetail>
                            <FrameDetailTitle>Datum: </FrameDetailTitle>{selectedFrameInfo.frdatum} mm
                          </FrameDetail>
                        </FrameContentContainer>
                      </FrameCard>
                    </FrameCardContainer>

                    <Row>
                      <FieldContainer>
                        <SelectWithLabel
                          label="Lens Material"
                          required={true}
                          options={lensMaterials}
                          onChange={(e) => setSelectedMaterial(e.target.value)}
                          value={selectedMaterial} />
                      </FieldContainer>
                      <FieldContainer>
                        <SelectWithLabel
                          label="Lens Types"
                          required={true}
                          options={lensTypes}
                          onChange={(e) => {
                            setSelectedType(e.target.value);
                            setSvType(null);
                          }}
                          value={selectedType}
                          missing={missingFields.selectedType} />
                      </FieldContainer>
                    </Row>
                    <Row>
                      <FieldContainer>
                        <SelectWithLabel
                          label="Lens Brand"
                          required={true}
                          options={lensBrands}
                          disabled={lensBrands.length === 0}
                          missing={missingFields.lenseID}
                          onChange={(e) => handleEnteredValues('lenseID', e.target.value)}
                          value={orderDetails.lenseID} />
                      </FieldContainer>
                      {svTypes.length > 0 &&
                        <FieldContainer>
                          <SelectWithLabel
                            label="SV Type"
                            required={true}
                            options={svTypes}
                            disabled={svTypes.length === 0}
                            onChange={(e) => setSvType(e.target.value)}
                            value={svType} />
                        </FieldContainer>}
                    </Row>
                    <Row>
                      <FieldContainer>
                        <SelectWithLabel
                          label="Lens Coating"
                          options={lensCoatings}
                          onChange={(e) => handleEnteredValues('lenseCoatID', e.target.value)}
                          disabled={lensCoatings.length === 0}
                          value={orderDetails.lenseCoatID} />
                      </FieldContainer>
                      <FieldContainer>
                        <SelectWithLabel
                          label="Lens Tints"
                          options={lensTints}
                          disabled={lensTints.length === 0}
                          onChange={(e) => handleEnteredValues('lenseTintID', e.target.value)}
                          value={orderDetails.lenseTintID} />
                      </FieldContainer>
                    </Row>
                    <Row>
                      <FieldContainer>
                        <SelectWithLabel
                          label="Spectacle Case"
                          required={true}
                          options={eyewearOptions}
                          disabled={eyewearOptions.length === 0}
                          onChange={(e) => handleEnteredValues('casesID', e.target.value)}
                          value={orderDetails.casesID} />
                      </FieldContainer>
                    </Row>

                    <RichTextBoxWithLabel
                      label="Additional Notes"
                      onChange={(e) => handleEnteredValues('rxNotes', e.target.value)}
                      value={orderDetails.rxNotes} />
                  </PrescriptionContainerLeft>
                  <PrescriptionContainerTwoColumn>
                    <PrescriptionTableRedesignTwoColumn
                      colours={colours}
                      data={prescriptionMeasures}
                      orderDetails={orderDetails}
                      handleEnteredValues={handleEnteredValues}
                      selectedLensType={selectedType}
                      SVType={svType}
                      missingFields={missingFields} />
                  </PrescriptionContainerTwoColumn>
                </>
              )}
              {currentStep === 2 && (
                <>
                  <br></br>
                  <Alert type='warning'>Please check your order requirements carefully. Upon completing this process, your prescription safety order will enter the manufacturing process and the order will be processed to your account. You will be able to view your order history and track each individual order.</Alert>
                  <p>Patient Details</p>
                  <FieldContainer>
                    <TextInputWithLabel
                      label='First name'
                      required={true}
                      value={orderDetails.privatePatient.firstName}
                      onChange={(e) => handleEnteredValues('privatePatient.firstName', e.target.value)}
                      missing={missingFields.firstName} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel
                      label='Surname'
                      required={true}
                      value={orderDetails.privatePatient.secondName}
                      onChange={(e) => handleEnteredValues('privatePatient.secondName', e.target.value)}
                      missing={missingFields.secondName} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel
                      label='Order No.'
                      required={true}
                      value={orderDetails.orderNumber}
                      onChange={(e) => handleEnteredValues('orderNumber', e.target.value)}
                      missing={missingFields.orderNumber} />
                  </FieldContainer>

                  <p>Glasses Delivery Address</p>

                  <FieldContainer>
                    <SelectWithLabel
                      label="Please select the delivery address*"
                      required={true}
                      options={deliveryAddressOptions}
                      onChange={() => setIsDeliveryAlternate(!isDeliveryAlternate)} />
                  </FieldContainer>
                  {isDeliveryAlternate &&
                    <>
                      <FieldContainer>
                        <TextInputWithLabel
                          label='Ref Name'
                          required={true}
                          value={orderDetails.deliveryAddress.companyname}
                          onChange={(e) => handleEnteredValues('deliveryAddress.companyname', e.target.value)}
                          missing={missingFields.companyname} />
                      </FieldContainer>
                      <FieldContainer>
                        <TextInputWithLabel
                          label='Address 1'
                          required={true}
                          value={orderDetails.deliveryAddress.coaddress1}
                          onChange={(e) => handleEnteredValues('deliveryAddress.coaddress1', e.target.value)}
                          missing={missingFields.coaddress1} />
                      </FieldContainer>
                      <FieldContainer>
                        <TextInputWithLabel
                          label='Address 2'
                          required={true}
                          value={orderDetails.deliveryAddress.coaddress2}
                          onChange={(e) => handleEnteredValues('deliveryAddress.coaddress2', e.target.value)}
                          missing={missingFields.coaddress2} />
                      </FieldContainer>
                      <FieldContainer>
                        <TextInputWithLabel
                          label='Address 3'
                          value={orderDetails.deliveryAddress.coaddress3}
                          required={true}
                          onChange={(e) => handleEnteredValues('deliveryAddress.coaddress3', e.target.value)}
                          missing={missingFields.coaddress3} />
                      </FieldContainer>
                      <FieldContainer>
                        <TextInputWithLabel
                          label='Postcode'
                          required={true}
                          value={orderDetails.deliveryAddress.copostcode}
                          onChange={(e) => handleEnteredValues('deliveryAddress.copostcode', e.target.value)}
                          missing={missingFields.copostcode}
                          invalidData={invalidPostcode} />
                      </FieldContainer>
                    </>
                  }

                  <p>Promotional Codes</p>
                  <FieldContainer>
                    <TextInputWithLabel
                      label='Promotional Code'
                      value={orderDetails.promotionCode}
                      onChange={(e) => handleEnteredValues('promotionCode', e.target.value)} />
                  </FieldContainer>
                  <p>Tracking</p>
                  <FieldContainer>
                    <YesNoSelect
                      label='Request Daily Tracking Updates?'
                      required={false}
                      value={orderDetails.isDailyOrderTrackingRequested}
                      onChange={(e) => handleEnteredValues('isDailyOrderTrackingRequested', parseInt(e.target.value))}
                      useNumbers={true} />
                  </FieldContainer>
                </>
              )}
            </ModalBody>
          )}
          <ModalFooter>
            {isLoading && <Alert type="info">Loading ..</Alert>}
            {invalidPromoCode && <Alert type='warning'>The entered promotional code is not valid.</Alert>}
            {Object.values(missingFields).some(isMissing => isMissing) &&
              (currentStep === 0 ?
                <Alert type='warning'>Please select a frame from the list above.</Alert>
                :
                <Alert type='warning'>Please populate all required fields indicated by an asterisk <span style={{ color: '#880808' }}> *</span></Alert>
              )
            }
            {currentStep > 0 && <Button disabled={isLoading} onClick={() => { setCurrentStep(currentStep - 1); setError(null) }}>Back</Button>}
            {currentStep < stepTitles.length - 1 ? (
              <Button
                onClick={nextStep}
                title={(!orderDetails.frameID && "You must select a frame before continuing to the next step.")}>
                Next
              </Button>
            ) : (
              <Button
                onClick={handleSavePrivateOrder}
                disabled={isLoading}>Submit Order</Button>)}
            <CancelButton disabled={isLoading} onClick={showHideModal}>Cancel</CancelButton>
          </ModalFooter>
        </StyledModal>
      </Modal>
    </>
  );
}
